export class MachineCategoryShareModel {
  constructor(public UserId: string, public CategoryId: number) {}
}
